export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Tipo de precio para la Web',
	plural_model_name_spanish: 'Tipos de precio para la Web',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}